import script from "./EventSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSelector.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__